import { IClient } from '../../../../Assembler/dist/registry/iface/iClient.js';
import type { ITransientStore } from '../../../../Assembler/dist/registry/iface/iTransientStore.js';
import type { GetParentJsonValueHandler } from '../../../../Assembler/dist/registry/iface/getParentJsonValueHandler.js';
import { JsonObject } from '../../../../Assembler/dist/app/json/jsonValue.js';
import { CounterFilter } from '../../registryCommon/dynamicData/counterFilter.js';

/**
 * Purpose:
 * Client-side CLIENT HANDLER for the counter capability — the "processor" half of the two-handler split.
 * Consumes the RAW counter island (produced by CounterClientData, the server "preparer") and projects it
 * into the final client-side result WITHOUT a server round-trip.
 *
 * Responsibilities:
 * - Parse the raw counter value and its key handed IN (never resolved/fetched here — source-agnostic)
 * - Project via the shared CounterFilter so the client tier is byte-identical to the server CounterData
 *
 * Distinct from CounterClientData (the server preparer): this is the client processor, registered on the
 * SEPARATE IClient registry. The same body runs in the browser bundle and in the console
 * --apiclient/--ociclient simulation, certifying the browser artifact by construction.
 *
 * Neither the transient store nor the App_Data store is read here. Counter state is server state; the
 * browser is handed the resolved outcome, which is what keeps this tier comparable to the server tier.
 */
export class CounterClient extends IClient {
    /**
     * Gets the full type name for client-handler operation tracking.
     */
    get typeName(): string {
        return 'CounterClient';
    }

    /**
     * Projects the RAW counter under the key carried in the island, REUSING the shared CounterFilter so the
     * client tier is byte-identical to the server GetData. Source-agnostic — the raw is handed in (embedded
     * data island / remote slice).
     */
    process(appSite: string, appView: string, appFile: string, componentName: string, componentDepth: number, resolvedAppSite: string, resolvedComponentName: string, paramJson: JsonObject, componentJson: JsonObject, transientStore: ITransientStore, configJson: JsonObject | null, getParentJsonValue: GetParentJsonValueHandler | null, rawJson: JsonObject): JsonObject {
        void appSite; void appView; void appFile; void componentName; void componentDepth; void resolvedAppSite; void resolvedComponentName; void paramJson; void componentJson; void transientStore; void configJson; void getParentJsonValue;
        const parsed = CounterFilter.parseRawCounter(rawJson);
        if (parsed === null) {
            return new JsonObject();
        }

        return CounterFilter.buildCounterResult(parsed.counterKey, parsed.counterValue);
    }
}
